

<div class="mt-4"> 
<h5> <strong> Security</strong></h5>
<p style="color: #6D6D6D;"> Adjust  Your Security Setting</p>
<div class="container-fluid">
    <div class="row">
        <div class="col-10 d-flex justify-content-between    justify-content-center align-items-center           language"> 
            
            <div class="d-flex gap-3"> 
            <p style="color: #6D6D6D;"> <b> Password</b></p>
            <p>Reset tour password regularly to keep you account secure </p>
            </div>
            <span  class="cursor"  data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style="color:#309EAE"><b> Reset</b> </span>
    </div>
    
</div>
<div class="row">
    <div class="col-10 d-flex justify-content-between    justify-content-center align-items-center  mt-3 language"> 
        
        <div class="d-flex gap-3"> 
        <p style="color: #6D6D6D;"><b> Active sessions </b> </p>
        <p>Selecting "sign out" will sign you out from all devices expect this one.This can take Few Minute  </p>
        </div>
        <span  class="cursor"  style="color:#309EAE">     <span class="CommingSoon"> Coming Soon </span> </span>
</div>
</div>
</div>

<!-- Canvas Part Start -->








<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasRightLabel">Reset Password</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="falseall()"></button>
  </div>
  <div class="offcanvas-body d-flex flex-column justify-content-between">
    <div *ngIf="currentpass" class="mb-3">
        <label for="exampleInputEmail1" class="form-label"> <strong>Current Password </strong>  </label>
        <input type="password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"  (input)="clearCurrentPassError()" [(ngModel)]="updatepass.password" >

      <p style="color: red;">{{currentpasserror}} </p>  
      </div>
      <div *ngIf="shownewpass"> 
      <div  class="mb-3">
        <label for="exampleInputEmail1" class="form-label"> <strong>New Password </strong>  </label>
        <input type="password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"  [(ngModel)]="updatepass.password" (input)="oldnewerror()" >
          <p style="color: red;">{{oldnewpassverifyerror}} </p>  
      </div>
      <div  class="mb-3">
        <label for="exampleInputEmail1" class="form-label"> <strong>Confirm new Password </strong>  </label>
        <input type="password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"  [(ngModel)]="confirmpass">
        
      </div>
    </div>
    <div *ngIf="showsuccess" class="d-flex flex-column justify-content-center align-items-center min-vh-100">
        <img src="assets/settingIcon/image.png" alt="Success" style="max-width: 200px;" />
        <b class="mt-3">Password Updated </b>
        
      </div>



      <button  *ngIf="currentpass" (click)="newpassword()"  class="reset"> <strong> Reset Password</strong>  </button>
      <button  *ngIf="shownewpass" (click)="showsucessfun()"       class="newpassbtn"> <strong> Confirm Password Update</strong>  </button>
  </div>
</div>